import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const toastrSuccessOptions = {
    icon: (
        <FontAwesomeIcon
            fixedWidth
            style={{ fontSize: 20 }}
            icon={['fas', 'check-circle']}
        />
    ),
};

export const toastrWarningOptions = {
    icon: (
        <FontAwesomeIcon
            fixedWidth
            icon={['fas', 'exclamation-circle']}
            style={{ fontSize: 20 }}
        />
    ),
};

export const toastrErrorOptions = {
    icon: (
        <FontAwesomeIcon
            fixedWidth
            icon={['fas', 'do-not-enter']}
            style={{ fontSize: 20 }}
        />
    ),
};
